// ********************************Import********************************************

// login, forgot password and change password

import Login from "./components/Login";
import forgotPassword from "./components/forgotPassword";
import resetPassword from "./components/resetPassword";
import changePassword from "./components/changePassword";
import CertificateDetails from "./components/CertificateDetails";
// Organizar Pages
import Focalpointlogin from "./pages/dashboard/Organizar/organizarLogin.vue";
import AddParticipants from "./pages/dashboard/Organizar/addParticipants.vue";

// Temporary
import MainDashboard from "./components/MainDashboard";

// Admin
import adminDashboardView from "./pages/dashboard/Admin/adminDashboardView";
import adminStaticsReport from "./pages/dashboard/Admin/adminStaticsReport";
import trainingsReportAdmin from "./pages/dashboard/Admin/trainingsReport";
import tematicAreaReport from "./pages/dashboard/Admin/thematicAreaReport";
import employeeReg from "./pages/dashboard/Admin/employeeReg";
import adminDashboard from "./pages/dashboard/Admin/adminDashboard";
import detailInfoTraining from "./pages/dashboard/Admin/detailInfoTraining";
import detailFundingAgencyTrainings from "./pages/dashboard/Admin/detailFundingAgencyTrainings";
import detailProgramOfficer from "./pages/dashboard/Admin/detailProgramOfficer";
import detailTrainer from "./pages/dashboard/Admin/detailTrainer";
import briefTrainingReportAdmin from "./pages/dashboard/Admin/briefTrainingReportAdmin";
import detailTrainingCompleted from "./pages/dashboard/Admin/detailTrainingCompleted";
import detailTrainee from "./pages/dashboard/Admin/detailTrainee";
import detailFundingAgency from "./pages/dashboard/Admin/detailFundingAgency";
import detailSubprogram from "./pages/dashboard/Admin/detailSubprogram";
import detailProject from "./pages/dashboard/Admin/detailProject";
import fundingAgency from "./pages/dashboard/Admin/fundingAgency";
import subProgram from "./pages/dashboard/Admin/subProgram";
import project from "./pages/dashboard/Admin/project";
import training from "./pages/dashboard/Admin/training";
import country from "./pages/dashboard/Admin/country";
import designation from "./pages/dashboard/Admin/designation";
import analysisReportAdmin from "./pages/dashboard/Admin/analysisReportAdmin";
import province from "./pages/dashboard/Admin/province";
import city from "./pages/dashboard/Admin/city";
import department from "./pages/dashboard/Admin/department";
import userDepartment from "./pages/dashboard/Admin/userDepartment";
import trainingCreate from "./pages/dashboard/Admin/trainingCreate";
import adminComingSoon from "./pages/dashboard/Admin/adminComingSoon";
import Reports from "./pages/dashboard/Admin/Reports";
import thematicArea from "./pages/dashboard/Admin/thematicArea";
import trainingReportList from "./pages/dashboard/Admin/trainingReportList";
import trainingReportSingle from "./pages/dashboard/Admin/trainingReportSingle";
import ReportsFilter from "./pages/dashboard/Admin/ReportsFilter";
import adminNewDashboardView from "./pages/dashboard/Admin/adminnewdashboardview";
import QuestionBankAdmin from "./pages/dashboard/Admin/QuestionBankAdmin";
import trainingReportSingleDetail from "./pages/dashboard/Admin/trainingReportSingleDetail";

import FeedBackTrainer from "./pages/dashboard/Admin/trainerFeedBackAnalysis.vue";
import trainingBriefReportAdmin from "./pages/dashboard/Admin/trainingBriefReport";
import analysisPostReportAdmin from "./pages/dashboard/Admin/analysisPostReportAdmin";
import analysisIndvidual from "./pages/dashboard/Admin/analysisIndvidual";
import PrintReportAdmin from "./pages/dashboard/Admin/PrintReportAdmin.vue";

import QuestionBankArchives from "./pages/dashboard/Admin/QuestionBankArchives";
import KnowledgeBaseArchives from "./pages/dashboard/Admin/KnowledgeBaseArchives";
import KnowledgeBaseArchivesDetail from "./pages/dashboard/Admin/KnowledgeBaseArchivesDetail";
import trainingType from "./pages/dashboard/Admin/trainingType";
import addThematicArea from "./pages/dashboard/Admin/addThematicArea";
import addTrainer from "./pages/dashboard/Admin/addTrainer";
import AddTrainee from "./pages/dashboard/Admin/addTrainee";
import subprogramList from "./pages/dashboard/Admin/subprogramList";
import projectList from "./pages/dashboard/Admin/projectList";
import role from "./pages/dashboard/Admin/role";
import relationDesignation from "./pages/dashboard/Admin/relationDesignation";
import profession from "./pages/dashboard/Admin/professions";
import academicInfo from "./pages/dashboard/Admin/academicInfo";
import Graphs from "./pages/dashboard/Admin/Graphs";
import trainingReport from "./pages/dashboard/Admin/trainingReport";
import assignedTrainingsToAdvisor from "./pages/dashboard/Admin/assignedTrainingsToAdvisor";
import programOfficerAssignedTrainings from "./pages/dashboard/Admin/programOfficerAssignedTrainings";
import ReportAdminGraphs from "./pages/dashboard/Admin/ReportAdminGraphs";
import trainingWizard from "./pages/dashboard/Admin/trainingWizard";
import adminTrainingWizardView from "./pages/dashboard/Admin/trainingWizardView";
import essentialSystem from "./pages/dashboard/Admin/essentialSystem";
import brief_training_report from "./pages/dashboard/programOfficer/brief_training_report";
import individual_analysis_report from "./pages/dashboard/programOfficer/individual_analysis_report";
import printReport from "./pages/dashboard/programOfficer/printReport";
import trainingAssignment from "./pages/dashboard/Advisor/trainingAssignment";
import trainingInformation from "./pages/dashboard/programOfficer/trainingInformation";
import trainingAgendaWizard from "./pages/dashboard/programOfficer/trainingAgendaWizard";

import wizardTraineeRegistration from "./pages/dashboard/programOfficer/wizardTraineeRegistration";
import wizardAssesmentReview from "./pages/dashboard/programOfficer/wizardAssesmentReview";
import wizardCompletion from "./pages/dashboard/programOfficer/wizardCompletion";
import StaticsReportPO from "./pages/dashboard/programOfficer/StaticsReportPO";

import analysisReport from "./pages/dashboard/programOfficer/analysisReport";
import analysisPostReport from "./pages/dashboard/programOfficer/analysisPostReport";
import reportsAdminAll from "./pages/dashboard/Admin/reportsAdminAll";
import strategicReport from "./pages/dashboard/Admin/strategicReport";
import map from "./pages/dashboard/Admin/map";
import ManageUnknowns from "./pages/dashboard/Admin/eventEnclosure.vue";
import AnalyticsGraphs from "./pages/dashboard/Admin/analytics";
import TrainingSetup from "./pages/dashboard/Admin/trainingSetup.vue";

// Advisor
import advisorDashboardView from "./pages/dashboard/Advisor/advisorDashboardView";
import TrainingsReportAdvisor from "./pages/dashboard/Advisor/TrainingsReportAdvisor";
import Advisor_Form from "./pages/dashboard/Advisor/Advisor_Form";
import AdvisorQuestionBank from "./pages/dashboard/Advisor/QuestionBank";
import AdvisorQuestionBankArchives from "./pages/dashboard/Advisor/QuestionBankArchives";
import AdvisortrainingReportSingleDetail from "./pages/dashboard/Advisor/trainingReportSingleDetail";
import AdvisorKnowledgeBaseArchives from "./pages/dashboard/Advisor/KnowledgeBaseArchives";
import briefTrainingReport from "./pages/dashboard/Advisor/briefTrainingReport";
import analysisReportAdvisor from "./pages/dashboard/Advisor/analysisReportAdvisor";

import analysisAdvisorPostReport from "./pages/dashboard/Advisor/analysisAdvisorPostReport";
import indvidualAdvisorReport from "./pages/dashboard/Advisor/indvidualAdvisorReport";
import AdvisorKnowledgeBaseArchivesDetail from "./pages/dashboard/Advisor/KnowledgeBaseArchivesDetail";
import advisorComingSoon from "./pages/dashboard/Advisor/advisorComingSoon";
import AdvisorDashboard from "./pages/dashboard/Advisor/AdvisorDashboard";
import ConductedTraining from "./pages/dashboard/Advisor/conductedTraining";
import InprocessTrainings from "./pages/dashboard/Advisor/InprocessTrainings";
import ApprovedTrainings from "./pages/dashboard/Advisor/ApprovedTrainings";
import trainingDetailView from "./pages/dashboard/Advisor/trainingDetailView";
import ReportsFilterAdvisor from "./pages/dashboard/Advisor/ReportsFilterAdvisor";
import ReportsAdvisor from "./pages/dashboard/Advisor/ReportsAdvisor";
import GraphsAdvisor from "./pages/dashboard/Advisor/GraphsAdvisor";
import trainingReportAdvisor from "./pages/dashboard/Advisor/trainingReportAdvisor";
import thematicAreaAdvisor from "./pages/dashboard/Advisor/thematicAreaAdvisor";
import ReportsAdvisorGraphs from "./pages/dashboard/Advisor/ReportsAdvisorGraphs";
import trainingReportListAdvisor from "./pages/dashboard/Advisor/trainingReportListAdvisor";
//import trainingReportSingle from "./pages/dashboard/Admin/trainingReportSingle";
import subprogramListAdvisor from "./pages/dashboard/Advisor/subprogramListAdvisor";
import projectListAdvisor from "./pages/dashboard/Advisor/projectListAdvisor";
import reportsAdvisorAll from "./pages/dashboard/Advisor/reportsAdvisorAll";
import thematicAreaReportAdvisor from "./pages/dashboard/Advisor/thematicAreaReportAdvisor";
import StaticsReportAdvisor from "./pages/dashboard/Advisor/StaticsReportAdvisor";
import AdvisorAnalytics from "./pages/dashboard/Advisor/AdvisorAnalytics.vue";
import TrainerFeedBackAdvisor from "./pages/dashboard/Advisor/trainerFeedBack.vue";

// Program Officer
import officerDashboardView from "./pages/dashboard/programOfficer/officerDashboardView";
import TrainingsReportOfficer from "./pages/dashboard/programOfficer/TrainingsReportOfficer";
import Form from "./pages/dashboard/programOfficer/Form";
import programOfficerknowledgeBase from "./pages/dashboard/programOfficer/knowledgeBase";
import QuestionBank from "./pages/dashboard/programOfficer/QuestionBank";
import AgendaForm from "./pages/dashboard/programOfficer/AgendaForm";
import programOfficer from "./pages/dashboard/programOfficer/todoList";
import ConductedTrainingOfficer from "./pages/dashboard/programOfficer/conductedTraining";
import Registration from "./pages/dashboard/programOfficer/Registration";
import quickTrainerReg from "./pages/dashboard/programOfficer/quickTrainerReg";
import traineesApproval from "./pages/dashboard/programOfficer/traineesApproval";
import traineeMaterialsApproval from "./pages/dashboard/programOfficer/traineeMaterialsApproval";
import DetailRegistration from "./pages/dashboard/programOfficer/DetailRegistration";
import officerComingSoon from "./pages/dashboard/programOfficer/officerComingSoon";
import programOfficerAssessment from "./pages/dashboard/programOfficer/Assessment";
import programOfficerPostAssessment from "./pages/dashboard/programOfficer/PostAssessment";
import createtrainerFeedback from "./pages/dashboard/programOfficer/createtrainerFeedback";
import createTraineesFeedback from "./pages/dashboard/programOfficer/createTraineesFeedback";
import programOfficerQuestionBankArchives from "./pages/dashboard/programOfficer/QuestionBankArchives";
import NestedPreAssessment from "./pages/dashboard/Admin/QBAComponents/PreAssessment";
import NestedPostAssessment from "./pages/dashboard/Admin/QBAComponents/PostAssessment";
import traineePreassessment from "./pages/dashboard/programOfficer/traineePreassessment";
import traineePreassessmentList from "./pages/dashboard/programOfficer/traineePreassessmentList";
import traineePreassessmentReport from "./pages/dashboard/programOfficer/traineePreassessmentReport";
import traineePostassessment from "./pages/dashboard/programOfficer/traineePostassessment";
import traineePostassessmentList from "./pages/dashboard/programOfficer/traineePostassessmentList";
import traineePostassessmentReport from "./pages/dashboard/programOfficer/traineePostassessmentReport";
import KnowledgeBaseArchive from "./pages/dashboard/programOfficer/KnowledgeBaseArchive";
import KnowledgeBaseArchiveDetail from "./pages/dashboard/programOfficer/KnowledgeBaseArchiveDetail";
import AddTraineePO from "./pages/dashboard/programOfficer/AddTraineePO";
import previewQuestions from "./pages/dashboard/programOfficer/previewQuestions";
import ReportsOfficer from "./pages/dashboard/programOfficer/ReportsOfficer";
import ReportsFilterOfficer from "./pages/dashboard/programOfficer/ReportsFilterOfficer";
import GraphsOfficer from "./pages/dashboard/programOfficer/GraphsOfficer";
import ReportsOfficerGraphs from "./pages/dashboard/programOfficer/ReportsOfficerGraphs";
import attendanceSheet from "./pages/dashboard/programOfficer/attendanceSheet";
import feedbackTrainer from "./pages/dashboard/programOfficer/feedbackTrainer";
import feedbackTrainee from "./pages/dashboard/programOfficer/feedbackTrainee";
import regFormTrainee from "./pages/dashboard/programOfficer/regFormTrainee";
import registerationReport from "./pages/dashboard/programOfficer/registerationReport";
import agendaFormReport from "./pages/dashboard/programOfficer/agendaFormReport";
import wizardTrainingAssesment from "./pages/dashboard/programOfficer/wizardTrainingAssesment";
import wizardTrainerRegistration from "./pages/dashboard/programOfficer/wizardTrainerRegistration";
import wizardUploadMaterial from "./pages/dashboard/programOfficer/wizardUploadMaterial";
import reportsOfficerAll from "./pages/dashboard/programOfficer/reportsOfficerAll";
import addCertificate from "./pages/dashboard/programOfficer/addCertificate";
import eventCertificate from "./pages/dashboard/CommunicationOfficer/eventCertificate";
import thematicAreaReportPO from "./pages/dashboard/programOfficer/thematicAreaReportPO";
import OfficerAnalytics from "./pages/dashboard/programOfficer/OfficerAnalytics.vue";
import PrintReportPO from "./pages/dashboard/programOfficer/PrintReportPO.vue";

// Trainer
import trainerDashboard from "./pages/dashboard/Trainer/trainerDashboard";
import Trainer_Registration_Form from "./pages/dashboard/Trainer/Trainer_Registration_Form";
import TrainerComingSoon from "./pages/dashboard/Trainer/comingSoon";
import TrainerInbox from "./pages/dashboard/Trainer/Inbox";
import trainerFeedback from "./pages/dashboard/Trainer/trainerFeedback";
import quickTraineeReg from "./pages/dashboard/Trainer/quickTraineeReg";
import TrainerknowledgeBase from "./pages/dashboard/Trainer/TrainerknowledgeBase";
import kBRepDetail from "./pages/dashboard/Trainer/knowledgeBaseRepDetail";
import trainingProg from "./pages/dashboard/Trainer/trainingProgInfo";
import uploadMaterial from "./pages/dashboard/Trainer/uploadTrainingMaterial";
import Trainer from "./pages/dashboard/Trainer/Gallery";
import trainerPrevTraining from "./pages/dashboard/Trainer/trainerPrevTraining";
import traineePrevTraining from "./pages/dashboard/Trainer/traineePrevTraining";
import reportsTrainerAll from "./pages/dashboard/Trainer/reportsTrainerAll";
import trainingAgenda from "./pages/dashboard/Trainer/trainingAgenda";
import trainerBriefTrainingReport from "./pages/dashboard/Trainer/brief_training_report";
import trainerAnalysisTrainingReport from "./pages/dashboard/Trainer/analysisReport";
import trainerIndvidualTrainingReport from "./pages/dashboard/Trainer/individual_analysis_report";

// Trainee
import traineeDashboard from "./pages/dashboard/Trainee/traineeDashboard";
import singleTrainingShow from "./pages/dashboard/Trainee/single-training-show";
import knowledgeBase from "./pages/dashboard/Trainee/knowledgeBase";
import TraineeReg from "./pages/dashboard/Trainee/TraineeReg";
import TraineeComingSoon from "./pages/dashboard/Trainee/comingSoon";
import addReference from "./pages/dashboard/Trainee/addReference";
import knowledgeBaseRepository from "./pages/dashboard/Trainee/knowledgeBaseRepository";
import knowledgeBaseRepDetail from "./pages/dashboard/Trainee/knowledgeBaseRepDetail";
import PreAssessment from "./pages/dashboard/Trainee/PreAssessment";
import PostAssessment from "./pages/dashboard/Trainee/PostAssessment";
import Inbox from "./pages/dashboard/Trainee/Inbox";
import Feedback from "./pages/dashboard/Trainee/Feedback";
import videos from "./pages/dashboard/Trainee/videos";
import Gallery from "./pages/dashboard/Trainee/Gallery";
import TrainerQuestionBank from "./pages/dashboard/Trainer/QuestionBank";
import Certificates from "./pages/dashboard/Trainee/Certificates";
import traineeQuestions from "./pages/dashboard/Trainee/traineeQuestions";
import changePasswordTrainee from "./pages/dashboard/Trainee/changePassword";

// communicationOfficer
import DashboardCO from "./pages/dashboard/CommunicationOfficer/dashboardCO";
import IndividualAnalysisCO from "./pages/dashboard/CommunicationOfficer/individualAnalysisCO";
import BriefTrainingReportCO from "./pages/dashboard/CommunicationOfficer/briefTrainingReportCO";
import AnalysisReportCO from "./pages/dashboard/CommunicationOfficer/analysisReportCO";
import AllReportsCO from "./pages/dashboard/CommunicationOfficer/allReportsCO";
import StartegicReportCO from "./pages/dashboard/CommunicationOfficer/strategicReportCO";
import EventReportCO from "./pages/dashboard/CommunicationOfficer/eventReportCO";
import StatisticalReportCO from "./pages/dashboard/CommunicationOfficer/statisticalReportCO";
import SocialMedia from "./pages/dashboard/CommunicationOfficer/socialMedia";
import DownloadCertificate from "./pages/dashboard/CommunicationOfficer/downloadEventCerticifates.vue";
import ThematicAreaReportCO from "./pages/dashboard/CommunicationOfficer/thematicAreaReportCO";
// import Certificate from "./pages/dashboard/CommunicationOfficer/certificate";

// Country Representative
import CountryRepresentative from "./pages/dashboard/CountryRepresentative/dashboard";
import IndividualAnalysis from "./pages/dashboard/CountryRepresentative/individualAnalysis";
import BriefTrainingReport from "./pages/dashboard/CountryRepresentative/briefTrainingReport";
import AnalysisReport from "./pages/dashboard/CountryRepresentative/analysisReportCR";
import AllReports from "./pages/dashboard/CountryRepresentative/allReports";
import StartegicReportCR from "./pages/dashboard/CountryRepresentative/startegicReportCR";
import EventReportCR from "./pages/dashboard/CountryRepresentative/eventReportCR";
import StatisticalReportCR from "./pages/dashboard/CountryRepresentative/statisticalReportCR";
import ThematicAreaReportCR from "./pages/dashboard/CountryRepresentative/thematicAreaReportCR";
import DeepAnalytics from "./pages/dashboard/CountryRepresentative/deepAnalytics";

//*********************************Exports links********************************************* */

// import { format } from "util";
const routes = [
  // login, forgot password and change password
  {
    path: "/focalpointlogin",
    name: "focalpointlogin",
    component: Focalpointlogin,
    meta: {
      title: "Focal login",
    },
  },
  {
    path: "/addParticipants",
    name: "addparticipants",
    component: AddParticipants,
    meta: {
      title: "Add Participants",
    },
  },
  {
    path: "/",
    name: "login",
    component: Login,
    meta: {
      title: "TMIS - United Nations Office on Drugs and Crime",
    },
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    component: forgotPassword,
  },
  {
    path: "/resetPassword/:token",
    name: "resetPassword",
    component: resetPassword,
  },
  {
    path: "/changePassword",
    name: "changePassword",
    component: changePassword,
  },
  {
    path: "/certificateDetails",
    name: "certificateDetails",
    component: CertificateDetails,
  },
  // Temporary
  {
    path: "/main-dashboard",
    name: "maindashboard",
    component: MainDashboard,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  // Admin
  {
    path: "/dashboard/Admin/feedBackTrainer",
    name: "FeedBackTrainer",
    component: FeedBackTrainer,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/adminDashboardView",
    name: "adminDashboardView",
    component: adminDashboardView,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/adminStaticsReport",
    name: "adminStaticsReport",
    component: adminStaticsReport,
    meta: {
      title: "Statistical Report",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingsReport",
    name: "trainingsReport",
    component: trainingsReportAdmin,
    meta: {
      title: "Trainings Report",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/thematicAreaReport",
    name: "thematicAreaReport",
    component: tematicAreaReport,
    meta: {
      title: "Thematic Report",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/adminDashboard",
    name: "adminDashboard",
    component: adminDashboard,
    meta: {
      title: "Explore Trainings",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailFundingAgencyTrainings",
    name: "detailFundingAgencyTrainings",
    component: detailFundingAgencyTrainings,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/PrintReportAdmin",
    name: "PrintReportAdmin",
    component: PrintReportAdmin,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingReportSingleDetail",
    name: "trainingReportSingleDetail",
    component: trainingReportSingleDetail,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/training/brief_training_report",
    name: "trainingBriefReportAdmin",
    component: trainingBriefReportAdmin,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/brief_training_report",
    name: "briefTrainingReportAdmin",
    component: briefTrainingReportAdmin,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/analysis-post-report",
    name: "analysisPostReportAdmin",
    component: analysisPostReportAdmin,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/individual_analysis_report",
    name: "analysisIndvidual",
    component: analysisIndvidual,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/detailProgramOfficer",
    name: "detailProgramOfficer",
    component: detailProgramOfficer,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/detailInfoTraining",
    name: "detailInfoTraining",
    component: detailInfoTraining,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailProgramOfficer",
    name: "detailProgramOfficer",
    component: detailProgramOfficer,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailTrainer",
    name: "detailTrainer",
    component: detailTrainer,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailTrainingCompleted",
    name: "detailTrainingCompleted",
    component: detailTrainingCompleted,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailTrainee",
    name: "detailTrainee",
    component: detailTrainee,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailFundingAgency",
    name: "detailFundingAgency",
    component: detailFundingAgency,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailSubprogram",
    name: "detailSubprogram",
    component: detailSubprogram,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/detailProject",
    name: "detailProject",
    component: detailProject,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/employeeReg",
    name: "employeeReg",
    component: employeeReg,
    meta: {
      title: "Employees",
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/fundingAgency",
    name: "fundingAgency",
    component: fundingAgency,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/subProgram",
    name: "subProgram",
    component: subProgram,
    meta: {
      title: "Subprogram",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/project",
    name: "project",
    component: project,
    meta: {
      title: "Project",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/training",
    name: "training",
    component: training,
    meta: {
      title: "Training",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/country",
    name: "country",
    component: country,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/province",
    name: "province",
    component: province,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/city",
    name: "city",
    component: city,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/designation",
    name: "designation",
    component: designation,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/role",
    name: "role",
    component: role,
    meta: {
      title: "Role",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/relation-designation",
    name: "relation",
    component: relationDesignation,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/profession",
    name: "profession",
    component: profession,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/department",
    name: "department",
    component: department,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/userDepartment",
    name: "userDepartment",
    component: userDepartment,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingCreate",
    name: "trainingCreate",
    component: trainingCreate,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/adminComingSoon",
    name: "adminComingSoon",
    component: adminComingSoon,
  },
  {
    path: "/dashboard/Admin/KnowledgeBaseArchives",
    name: "KnowledgeBaseArchives",
    component: KnowledgeBaseArchives,
    meta: {
      title: "Knowledge Base",
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/KnowledgeBaseArchivesDetail",
    name: "KnowledgeBaseArchivesDetail",
    component: KnowledgeBaseArchivesDetail,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/questionbankarchives",
    name: "QuestionBankArchives",
    component: QuestionBankArchives,
    children: [
      //UserInfo component is rendered when /user/:id is matched
      { path: "PostAssessment", component: NestedPostAssessment, props: true },
      { path: "PreAssessment", component: NestedPreAssessment, props: true },
    ],
    meta: {
      title: "Question Archives",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/programOfficer/traineePreassessment",
    name: "traineePreassessment",
    component: traineePreassessment,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/StaticsReportPO",
    name: "StaticsReportPO",
    component: StaticsReportPO,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/admin/trainingWizard",
    name: "traineePreassessment",
    component: trainingWizard,
    meta: {
      title: "Event Wizard",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/manageUnknowns",
    name: "manageUnknowns",
    component: ManageUnknowns,
    meta: {
      title: "Manage Unknowns",
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/admin/training_wizard",
    name: "adminTrainingWizardView",
    component: adminTrainingWizardView,
    meta: {
      title: "Event Wizard",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/admin/essentialSystem",
    name: "essentialSystem",
    component: essentialSystem,
    meta: {
      title: "Essential Data",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/analytics",
    name: "analytics",
    component: AnalyticsGraphs,
    meta: {
      title: "Analytics",
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingSetup",
    name: "trainingSetup",
    component: TrainingSetup,
    meta: {
      title: "Training Setup",
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/programOfficer/brief_training_report",
    name: "brief_training_report",
    component: brief_training_report,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/individual_analysis_report",
    name: "individual_analysis_report",
    component: individual_analysis_report,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/printReport",
    name: "printReport",
    component: printReport,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/addCertificate",
    name: "addCertificate",
    component: addCertificate,
    meta: {
      title: "Certificate",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/advisor/training-Assignment",
    name: "trainingAssignment",
    component: trainingAssignment,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/advisor/StaticsReportAdvisor",
    name: "StaticsReportAdvisor",
    component: StaticsReportAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/advisor/trainerFeedBackAdvisor",
    name: "TrainerFeedBackAdvisor",
    component: TrainerFeedBackAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/programOfficer/training-Information",
    name: "trainingInformation",
    component: trainingInformation,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/trainer-registration",
    name: "wizardTrainerRegistration",
    component: wizardTrainerRegistration,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/trainee-registration",
    name: "wizardTraineeRegistration",
    component: wizardTraineeRegistration,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/thematicAreaReport",
    name: "thematicAreaReportPO",
    component: thematicAreaReportPO,
    meta: {
      title: "Thematic Report",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/programOfficer/wizard-completion",
    name: "wizardCompletion",
    component: wizardCompletion,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/PrintReportPO",
    name: "PrintReportPO",
    component: PrintReportPO,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/analytics",
    name: "OfficerAnalytics",
    component: OfficerAnalytics,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/assesment-review",
    name: "wizardAssesmentReview",
    component: wizardAssesmentReview,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/training-agenda",
    name: "trainingAgendaWizard",
    component: trainingAgendaWizard,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/analysis-report",
    name: "analysisReport",
    component: analysisReport,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/admin/analysis-report",
    name: "analysisReportAdmin",
    component: analysisReportAdmin,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/advisor/analysis-report",
    name: "analysisReportAdvisor",
    component: analysisReportAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/advisor/advisorDashboardView",
    name: "advisorDashboardView",
    component: advisorDashboardView,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/advisor/TrainingsReportAdvisor",
    name: "TrainingsReportAdvisor",
    component: TrainingsReportAdvisor,
    meta: {
      title: "Trainings Report",
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/programOfficer/analysis-post-report",
    name: "analysisPostReport",
    component: analysisPostReport,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/advisor/analysis-post-report",
    name: "analysisAdvisorPostReport",
    component: analysisAdvisorPostReport,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/advisor/thematicAreaReport",
    name: "thematicAreaReportAdvisor",
    component: thematicAreaReportAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/programOfficer/traineePostassessment",
    name: "traineePostassessment",
    component: traineePostassessment,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/traineePreassessmentList",
    name: "traineePreassessmentList",
    component: traineePreassessmentList,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/traineePreassessmentReport",
    name: "traineePreassessmentReport",
    component: traineePreassessmentReport,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/traineePostassessmentList",
    name: "traineePostassessmentList",
    component: traineePostassessmentList,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/programOfficer/traineePostassessmentReport",
    name: "traineePostassessmentReport",
    component: traineePostassessmentReport,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/Admin/questionBankAdmin",
    name: "QuestionBankAdmin",
    component: QuestionBankAdmin,
    meta: {
      title: "Question Bank",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingType",
    name: "trainingType",
    component: trainingType,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/addThematicArea",
    name: "addThematicArea",
    component: addThematicArea,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/addTrainer",
    name: "addTrainer",
    component: addTrainer,
    meta: {
      title: "Facilitators",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/addTrainee",
    name: "addTrainee",
    component: AddTrainee,
    meta: {
      title: "Participant",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/subprogramList",
    name: "subprogramList",
    component: subprogramList,
    meta: {
      title: "Subprogram",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/projectList",
    name: "projectList",
    component: projectList,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/Reports",
    name: "Reports",
    component: Reports,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingReportList",
    name: "trainingReportList",
    component: trainingReportList,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingReportSingle",
    name: "trainingReportSingle",
    component: trainingReportSingle,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/thematicArea",
    name: "thematicArea",
    component: thematicArea,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/ReportsFilter",
    name: "ReportsFilter",
    component: ReportsFilter,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/new-dashboard",
    name: "adminNewDashboard",
    component: adminNewDashboardView,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/academicInfo",
    name: "academicInfo",
    component: academicInfo,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/graphs",
    name: "Graphs",
    component: Graphs,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/trainingReport",
    name: "trainingReport",
    component: trainingReport,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/assignedTrainingsToAdvisor",
    name: "assignedTrainingsToAdvisor",
    component: assignedTrainingsToAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/programOfficerAssignedTrainings",
    name: "programOfficerAssignedTrainings",
    component: programOfficerAssignedTrainings,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/ReportAdminGraphs",
    name: "ReportAdminGraphs",
    component: ReportAdminGraphs,
    meta: {
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/reportsAdminAll",
    name: "reportsAdminAll",
    component: reportsAdminAll,
    meta: {
      title: "Brief Report",
      requiresAuth: true,
      isPermission: "admin",
    },
  },
  {
    path: "/dashboard/Admin/strategicReport",
    name: "strategicReport",
    component: strategicReport,
    meta: {
      title: "Startegic Report",
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  {
    path: "/dashboard/Admin/map",
    name: "map",
    component: map,
    meta: {
      title: "Map",
      requiresAuth: true,
      isPermission: "admin",
    },
  },

  // Advisor
  {
    path: "/dashboard/Advisor",
    name: "advisor_form",
    component: Advisor_Form,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },

  {
    path: "/dashboard/Advisor/QuestionBank",
    name: "QuestionBank",
    component: AdvisorQuestionBank,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/advisor/individual_analysis_report",
    name: "indvidualAdvisorReport",
    component: indvidualAdvisorReport,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },

  {
    path: "/dashboard/advisor/brief_training_report",
    name: "briefTrainingReport",
    component: briefTrainingReport,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },

  {
    path: "/dashboard/Advisor/trainingReportSingleDetail",
    name: "AdvisortrainingReportSingleDetail",
    component: AdvisortrainingReportSingleDetail,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/advisorComingSoon",
    name: "advisorComingSoon",
    component: advisorComingSoon,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/analytics",
    name: "AdvisorAnalytics",
    component: AdvisorAnalytics,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/questionbankarchives",
    name: "AdvisorQuestionBankArchives",
    component: AdvisorQuestionBankArchives,
    meta: {
      title: "Question Bank",
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/KnowledgeBaseArchives",
    name: "AdvisorKnowledgeBaseArchives",
    component: AdvisorKnowledgeBaseArchives,
    meta: {
      title: "Knowledge Archives",
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/KnowledgeBaseArchivesDetail",
    name: "AdvisorKnowledgeBaseArchivesDetail",
    component: AdvisorKnowledgeBaseArchivesDetail,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/advisordashboard",
    name: "AdvisorDashboard",
    component: AdvisorDashboard,
    meta: {
      title: "Explore Trainings",
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/conductedTraining",
    name: "ConductedTraining",
    component: ConductedTraining,
    meta: {
      title: "Assigned Trainings",
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/inprocesstrainings",
    name: "InprocessTrainings",
    component: InprocessTrainings,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/approvedtrainings",
    name: "ApprovedTrainings",
    component: ApprovedTrainings,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/trainingDetailView",
    name: "trainingDetailView",
    component: trainingDetailView,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/ReportsAdvisorGraphs",
    name: "ReportsAdvisorGraphs",
    component: ReportsAdvisorGraphs,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/ReportsFilterAdvisor",
    name: "ReportsFilterAdvisor",
    component: ReportsFilterAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/ReportsAdvisor",
    name: "ReportsAdvisor",
    component: ReportsAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/GraphsAdvisor",
    name: "GraphsAdvisor",
    component: GraphsAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/trainingReportAdvisor",
    name: "trainingReportAdvisor",
    component: trainingReportAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/thematicAreaAdvisor",
    name: "thematicAreaAdvisor",
    component: thematicAreaAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/trainingReportListAdvisor",
    name: "trainingReportListAdvisor",
    component: trainingReportListAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  // {
  //     path: "/dashboard/Admin/trainingReportSingle",
  //     name: "trainingReportSingle",
  //     component: trainingReportSingle
  // },
  {
    path: "/dashboard/Advisor/subprogramListAdvisor",
    name: "subprogramListAdvisor",
    component: subprogramListAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/projectListAdvisor",
    name: "projectListAdvisor",
    component: projectListAdvisor,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },
  {
    path: "/dashboard/Advisor/reportsAdvisorAll",
    name: "reportsAdvisorAll",
    component: reportsAdvisorAll,
    meta: {
      requiresAuth: true,
      isPermission: "advisor",
    },
  },

  // Program Officer
  {
    path: "/dashboard/program-officer/todoList",
    name: "programOfficer",
    component: programOfficer,
    meta: {
      title: "Explore Trainings",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/conductedTraining",
    name: "ConductedTrainingOfficer",
    component: ConductedTrainingOfficer,
    meta: {
      title: "Assigned Trainings",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/form",
    name: "form",
    component: Form,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/registration",
    name: "Registration",
    component: Registration,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/quickTrainerReg",
    name: "Registration",
    component: quickTrainerReg,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/trainees-approval",
    name: "traineesApproval",
    component: traineesApproval,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/trainee-material-approval",
    name: "traineeMaterialsApproval",
    component: traineeMaterialsApproval,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/detail-registration",
    name: "DetailRegistration",
    component: DetailRegistration,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/knowledgeBase",
    name: "knowledge-base",
    component: programOfficerknowledgeBase,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/QuestionBank",
    name: "QuestionBank",
    component: QuestionBank,
    meta: {
      title: "Create Question",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/AgendaForm",
    name: "AgendaForm",
    component: AgendaForm,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/program-officer/officerComingSoon",
    name: "officerComingSoon",
    component: officerComingSoon,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/assessment",
    name: "programOfficerAssessment",
    component: programOfficerAssessment,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/postassessment",
    name: "programOfficerPostAssessment",
    component: programOfficerPostAssessment,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/createtrainerFeedback",
    name: "createtrainerFeedback",
    component: createtrainerFeedback,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/createTraineesFeedback",
    name: "createTraineesFeedback",
    component: createTraineesFeedback,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/questionbankarchives",
    name: "programOfficerQuestionBankArchives",
    component: programOfficerQuestionBankArchives,
    meta: {
      title: "Question Bank",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/KnowledgeBaseArchive",
    name: "KnowledgeBaseArchive",
    component: KnowledgeBaseArchive,
    meta: {
      title: "Knowledge Base",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/KnowledgeBaseArchiveDetail",
    name: "KnowledgeBaseArchiveDetail",
    component: KnowledgeBaseArchiveDetail,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/addTrainee",
    name: "AddTraineePO",
    component: AddTraineePO,
    meta: {
      title: "Participant",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/program-officer/previewQuestions",
    name: "previewQuestions",
    component: previewQuestions,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/ReportsFilterOfficer",
    name: "ReportsFilterOfficer",
    component: ReportsFilterOfficer,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/officerDashboardView",
    name: "officerDashboardView",
    component: officerDashboardView,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/TrainingsReportOfficer",
    name: "TrainingsReportOfficer",
    component: TrainingsReportOfficer,
    meta: {
      title: "Trainings Report",
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/ReportsOfficer",
    name: "ReportsOfficer",
    component: ReportsOfficer,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/GraphsOfficer",
    name: "GraphsOfficer",
    component: GraphsOfficer,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/programOfficer/ReportsOfficerGraphs",
    name: "ReportsOfficerGraphs",
    component: ReportsOfficerGraphs,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/attendanceSheet",
    name: "attendanceSheet",
    component: attendanceSheet,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/feedbackTrainer",
    name: "feedbackTrainer",
    component: feedbackTrainer,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/feedbackTrainee",
    name: "feedbackTrainee",
    component: feedbackTrainee,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/regFormTrainee",
    name: "regFormTrainee",
    component: regFormTrainee,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/registerationReport",
    name: "registerationReport",
    component: registerationReport,
  },
  {
    path: "/dashboard/programOfficer/agendaFormReport",
    name: "agendaFormReport",
    component: agendaFormReport,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/training-assesment",
    name: "wizardTrainingAssesment",
    component: wizardTrainingAssesment,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  {
    path: "/dashboard/programOfficer/wizardUploadMaterial",
    name: "wizardUploadMaterial",
    component: wizardUploadMaterial,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },
  {
    path: "/dashboard/programOfficer/reportsOfficerAll",
    name: "reportsOfficerAll",
    component: reportsOfficerAll,
    meta: {
      requiresAuth: true,
      isPermission: "program_officer",
    },
  },

  // Trainer
  {
    path: "/dashboard/Trainer/Trainer_Registration_Form",
    name: "trainer-registration",
    component: Trainer_Registration_Form,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/trainerDashboard",
    name: "TraineeReg",
    component: trainerDashboard,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/brief_training_report",
    name: "BriefTrainingReportT",
    component: trainerBriefTrainingReport,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/analysisReport",
    name: "BriefTrainingAnalysisReportT",
    component: trainerAnalysisTrainingReport,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/individual_analysis_report",
    name: "BriefTrainingIndvidualReportT",
    component: trainerIndvidualTrainingReport,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },

  {
    path: "/dashboard/Trainer/comingSoon",
    name: "TraineeReg",
    component: TrainerComingSoon,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/inbox",
    name: "TrainerInbox",
    component: TrainerInbox,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/trainerFeedback",
    name: "trainerFeedback",
    component: trainerFeedback,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/quickTraineeReg",
    name: "quickTraineeReg",
    component: quickTraineeReg,
  },
  {
    path: "/dashboard/Trainer/QuestionBank",
    name: "QuestionBank",
    component: TrainerQuestionBank,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/TrainerknowledgeBase",
    name: "TrainerknowledgeBase",
    component: TrainerknowledgeBase,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/knowledgeBaseRepDetail",
    name: "knowledgeBaseRepDetail",
    component: kBRepDetail,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/trainingProgInfo",
    name: "trainingProg",
    component: trainingProg,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/uploadTrainingMaterial",
    name: "uploadMaterial",
    component: uploadMaterial,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/Gallery",
    name: "videosTrainer",
    component: Trainer,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/trainerPrevTraining",
    name: "trainerPrevTraining",
    component: trainerPrevTraining,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/traineePrevTraining",
    name: "traineePrevTraining",
    component: traineePrevTraining,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/trainer/reportsTrainerAll",
    name: "reportsTrainerAll",
    component: reportsTrainerAll,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },
  {
    path: "/dashboard/Trainer/trainingAgenda",
    name: "trainingAgenda",
    component: trainingAgenda,
    meta: {
      requiresAuth: true,
      isPermission: "trainer",
    },
  },

  // Trainee

  {
    path: "/dashboard/Trainee/traineeDashboard",
    name: "traineeDashboard",
    component: traineeDashboard,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/change-password",
    name: "changePasswordTrainee",
    component: changePasswordTrainee,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  // this will show single training of a trainee
  {
    path: "/dashboard/Trainee/single-training-show",
    name: "singleTrainingShow",
    component: singleTrainingShow,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/knowledgeBase",
    name: "knowledge-base",
    component: knowledgeBase,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },

  {
    path: "/dashboard/Trainee/addReference",
    name: "addReference",
    component: addReference,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },

  {
    path: "/dashboard/Trainee/TraineeReg",
    name: "TraineeReg",
    component: TraineeReg,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },

  {
    path: "/dashboard/Trainee/comingSoon",
    name: "TraineeReg",
    component: TraineeComingSoon,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/preassessment",
    name: "PreAssessment",
    component: PreAssessment,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/postassessment",
    name: "PostAssessment",
    component: PostAssessment,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/inbox",
    name: "Inbox",
    component: Inbox,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/feedback",
    name: "Feedback",
    component: Feedback,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/knowledgeBaseRepository",
    name: "knowledgeBaseRepository",
    component: knowledgeBaseRepository,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/trainee-questions",
    name: "traineeQuestions",
    component: traineeQuestions,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/knowledgeBaseRepDetail",
    name: "knowledgeBaseRepDetail",
    component: knowledgeBaseRepDetail,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/videos",
    name: "videos",
    component: videos,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/gallery",
    name: "Gallery",
    component: Gallery,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },
  {
    path: "/dashboard/Trainee/certificates",
    name: "Certificates",
    component: Certificates,
    meta: {
      requiresAuth: true,
      isPermission: "trainee",
    },
  },

  // Communictaion Officer

  {
    path: "/dashboard/communicationOfficer/dashboardCO",
    name: "Dashboard",
    component: DashboardCO,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  {
    path: "/dashboard/communicationOfficer/individualAnalysisCO",
    name: "individualAnalysis",
    component: IndividualAnalysisCO,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  {
    path: "/dashboard/communicationOfficer/briefTrainingReportCO",
    name: "briefTrainingReport",
    component: BriefTrainingReportCO,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  {
    path: "/dashboard/communicationOfficer/analysisReportCO",
    name: "analysisReport",
    component: AnalysisReportCO,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  {
    path: "/dashboard/communicationOfficer/allReportsCO",
    name: "allReportsCO",
    component: AllReportsCO,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  {
    path: "/dashboard/communicationOfficer/strategicReportCO",
    name: "strategicReportCO",
    component: StartegicReportCO,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  {
    path: "/dashboard/communicationOfficer/eventReportCO",
    name: "eventReportCO",
    component: EventReportCO,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  {
    path: "/dashboard/communicationOfficer/statisticalReportCO",
    name: "statisticalReportCO",
    component: StatisticalReportCO,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  {
    path: "/dashboard/communicationOfficer/socialMedia",
    name: "socialMedia",
    component: SocialMedia,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  // {
  //   path: "/dashboard/communicationOfficer/certificate",
  //   name: "certificate",
  //   component: Certificate,
  //   meta: {
  //     requiresAuth: true,
  //     isPermission: "comm_officer",
  //   },
  // },
  {
    path: "/dashboard/communicationOfficer/downloadCertificate",
    name: "DownloadCertificate",
    component: DownloadCertificate,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  {
    path: "/dashboard/communicationOfficer/thematicAreaReportCO",
    name: "thematicAreaReportCO",
    component: ThematicAreaReportCO,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  {
    path: "/dashboard/communicationOfficer/eventCertificate",
    name: "eventCertificate",
    component: eventCertificate,
    meta: {
      requiresAuth: true,
      isPermission: "comm_officer",
    },
  },
  // Country Representative

  {
    path: "/dashboard/CountryRepresentative/dashboard",
    name: "Dashboard",
    component: CountryRepresentative,
    meta: {
      requiresAuth: true,
      isPermission: "country_represent",
    },
  },
  {
    path: "/dashboard/CountryRepresentative/individualAnalysis",
    name: "individualAnalysis",
    component: IndividualAnalysis,
    meta: {
      requiresAuth: true,
      isPermission: "country_represent",
    },
  },
  {
    path: "/dashboard/CountryRepresentative/briefTrainingReport",
    name: "briefTrainingReport",
    component: BriefTrainingReport,
    meta: {
      requiresAuth: true,
      isPermission: "country_represent",
    },
  },
  {
    path: "/dashboard/CountryRepresentative/analysisReport",
    name: "analysisReport",
    component: AnalysisReport,
    meta: {
      requiresAuth: true,
      isPermission: "country_represent",
    },
  },
  {
    path: "/dashboard/CountryRepresentative/allReports",
    name: "allReports",
    component: AllReports,
    meta: {
      requiresAuth: true,
      isPermission: "country_represent",
    },
  },
  {
    path: "/dashboard/CountryRepresentative/strategicReportCR",
    name: "strategicReportCR",
    component: StartegicReportCR,
    meta: {
      requiresAuth: true,
      isPermission: "country_represent",
    },
  },
  {
    path: "/dashboard/CountryRepresentative/eventReportCR",
    name: "eventReportCR",
    component: EventReportCR,
    meta: {
      requiresAuth: true,
      isPermission: "country_represent",
    },
  },
  {
    path: "/dashboard/CountryRepresentative/statisticalReportCR",
    name: "statisticalReportCR",
    component: StatisticalReportCR,
    meta: {
      requiresAuth: true,
      isPermission: "country_represent",
    },
  },
  {
    path: "/dashboard/CountryRepresentative/thematicAreaReportCR",
    name: "thematicAreaReportCR",
    component: ThematicAreaReportCR,
    meta: {
      requiresAuth: true,
      isPermission: "country_represent",
    },
  },
  {
    path: "/dashboard/CountryRepresentative/deepAnalytics",
    name: "deepAnalytics",
    component: DeepAnalytics,
    meta: {
      requiresAuth: true,
      isPermission: "country_represent",
    },
  },
];

export default routes;
